import "starknet";
import "./connector-c50f5de7.js";
import "./getStarknetChainId-7c4b3163.js";
import { A as p, a as s, i as a } from "./index-32a1e8d5.js";
import "./index-ae0f52d0.js";
export {
  p as ArgentMobileBaseConnector,
  s as ArgentMobileConnector,
  a as isInArgentMobileAppBrowser
};
